import React from "react"

import TextInput from "@/pages/Attendance/Chat/ConversationPanel/Input/TextInput"
import { ButtonMessageData } from "@/protocols/channel"
import { Grid, IconButton, InputAdornment } from "@material-ui/core"
import {
	Close as CloseIcon
} from "@material-ui/icons"
import { Text, themeColors } from "letalkui"
import { ValidationType } from "@/hooks/useValidation"

type ManageTemplateQuickReplyButtonProps = {
	index: number
	button: ButtonMessageData
	validation?: ValidationType
	handleButtonTextChange: (text: string, index: number) => void
	handleRemoveButtons: (index: number) => void
}

const ManageTemplateQuickReplyButton: React.FC<ManageTemplateQuickReplyButtonProps> = (props) => {
	const { button, index, validation, handleButtonTextChange, handleRemoveButtons } = props

	return (
		<Grid item>
			<Grid container alignItems="center" direction="row" spacing={2} xs={12}>
				<Grid item xs={11}>
					<TextInput
						defaultValue={button?.text}
						inputProps={{ maxLength: 25 }}
						isOutlined
						onMedia={() => ""}
						onSubmit={() => ""}
						onChange={(value) => {
							handleButtonTextChange(value || button.text, index)
						}}
					/>
					{!!validation?.[`buttons[${index}].text`] && (
						<Grid item>
							<Text.Body
								type="smaller2"
								color={themeColors.getTextErrorColor()}
							>
								{validation[`buttons[${index}].text`]}
							</Text.Body>
						</Grid>
					)}
				</Grid>
				<Grid item xs={1}>
					<InputAdornment position="end">
						<IconButton size="small" onClick={() => handleRemoveButtons(index)}>
							<CloseIcon fontSize="small" />
						</IconButton>
					</InputAdornment>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ManageTemplateQuickReplyButton
